export const faCenterHorizontally = {
  prefix: 'fpm',
  iconName: 'fa-center-horizontally',
  icon: [
    24,
    24,
    [],
    'e001',
    'M11.04 4.88v1.88H7.28v3.92h3.76v3.28H5v3.92h6.04v3.76h1v-3.76h6.04v-3.92h-6.04v-3.28h3.76V6.76h-3.76V3h-1v1.88',
  ],
};
